module.exports = __webpack_public_path__ + "static/media/Babys-dream-1.6da8f11b.png";